// Web / Telegram: no background alarms. We ring in-app while the page is open.
const pending = new Map<string, ReturnType<typeof setTimeout>>();
let counter = 0;
const listeners = new Set<(title: string) => void>();

/** In-app ring callback (web only). Returns an unsubscribe function. */
export function onAlarm(cb: (title: string) => void): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export async function scheduleAlarm(at: number, title: string, body: string): Promise<string> {
  const id = `web-${++counter}`;
  const delay = Math.max(0, at - Date.now());
  pending.set(
    id,
    setTimeout(() => {
      pending.delete(id);
      if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
        new Notification(title, { body });
      }
      listeners.forEach(l => l(title));
    }, delay),
  );
  if (typeof Notification !== 'undefined' && Notification.permission === 'default') {
    Notification.requestPermission().catch(() => {});
  }
  return id;
}

export async function cancelAlarm(id: string): Promise<void> {
  clearTimeout(pending.get(id));
  pending.delete(id);
}

export const firesInBackground = false;
